var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-card"},[_c('div',{staticClass:"card col-md-6"},[_c('h3',[_vm._v("Nașterea pe cale naturală")]),_c('p',[_vm._v("este de preferat nașterii prin cezariană pentru că bebelușul preia prin canalul vaginal bacteriile bune. Acestea au grijă ca flora intestinală să rămână echilibrată.")])])])
}]

export { render, staticRenderFns }